import { BrainLoadingIcon } from 'morpheus-ui';
import { VariantProps } from 'tailwind-variants';
import { Typography } from '../Typography';
import { brainIcon } from './variants';

interface IBrainLoading extends VariantProps<typeof brainIcon> {
  customMessage?: string;
}

export default function BrainLoadingWrapper({
  size = 'lg',
  type = 'primary',
  customMessage,
}: IBrainLoading) {
  const messages = [
    'Criando sinapses...',
    'Transmitindo impulsos nervosos...',
    'Liberando neurotransmissores...',
    'Despolarizando membrana...',
  ];

  return (
    <div className='mt-10 flex h-fit w-full flex-col items-center justify-center gap-xl'>
      <BrainLoadingIcon className={brainIcon({ size, type })} />
      <Typography className='text-brand-color-primary-pure dark:text-mono-color-black'>
        {customMessage || messages[Math.floor(Math.random() * 4)]}
      </Typography>
    </div>
  );
}
